export const reservedEvents: string[] = ['link', 'toast'];
